module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_7.40d9893f.png";